import {
  Required,
  IsString,
  IsNumber,
  IsArray,
  ValidateNested,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from "./api";

interface WorkspaceTeamResponse {
  response: {
    workspaces: [
      {
        id: string;
        name: string;
        description: string;
        user_id: string;
        member_count: number;
        role: string;
        status: string;
        created_at: string;
        updated_at: string;
      }
    ];
    total: number;
    page: number;
    page_size: number;
  };
}

// Workspace 嵌套类
class Workspace {
  @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;

  @Required("Role cannot be empty")
  @IsString("Role must be a string")
  role: string;

  @IsNumber("MemberCount must be a number")
  memberCount: number;
}

// Response 嵌套类
class WorkspaceTeamResponseData {
  @Required("Workspaces cannot be empty")
  @IsArray("Workspaces must be an array")
  @ValidateNested(Workspace)
  workspaces: Workspace[];

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Page cannot be empty")
  @IsNumber("Page must be a number")
  page: number;

  @Required("Page size cannot be empty")
  @IsNumber("Page size must be a number")
  pageSize: number;
}

// 主数据类
export class WorkspaceTeamData {
  @Required("Response cannot be empty")
  response: WorkspaceTeamResponseData;
}

const transformAndValidateWorkspaceTeam = (
  response: WorkspaceTeamResponse
): WorkspaceTeamData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, WorkspaceTeamData);
  } catch (error: any) {
    console.error("Workspace team data validation failed:", error.message);
    throw error;
  }
};

export async function workspaceTeam({
  teamCode,
}: {
  teamCode: string;
}): Promise<WorkspaceTeamData> {
  const res = await api.post<WorkspaceTeamResponse>("/workspace/team", {
    team_code: teamCode,
    page: 1,
    page_size: 1000,
  });
  const validatedData = transformAndValidateWorkspaceTeam(res.data);
  return validatedData;
}